export default __webpack_public_path__ + "static/media/minus.c675ebab.svg";